export default "__VITE_ASSET__BFmejJ3T__"